import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=55d14aaa&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"
import style0 from "./Orders.vue?vue&type=style&index=0&id=55d14aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d14aaa",
  null
  
)

export default component.exports